import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import { useNotifications } from "reapop";

// Section (heading / subheading / leads / CTA)
export const GetMedicinalChemistryCroSection = () => {
  return useQuery({
    queryKey: ["get-medicinal-chemistry-cro-section"],
    queryFn: () => client.medicinalChemistryCro.getSection(),
  });
};

export const UpdateMedicinalChemistryCroSection = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: (data) => client.medicinalChemistryCro.updateSection(data),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "Section updated successfully!", "success");
        queryClient.invalidateQueries(["get-medicinal-chemistry-cro-section"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to update section!", "error");
    },
  });
};

// Tags
export const GetMedicinalChemistryCroTags = () => {
  return useQuery({
    queryKey: ["get-medicinal-chemistry-cro-tags"],
    queryFn: () => client.medicinalChemistryCro.getAllTags(),
  });
};

export const AddMedicinalChemistryCroTag = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: (data) => client.medicinalChemistryCro.addTag(data),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "Tag added successfully!", "success");
        queryClient.invalidateQueries(["get-medicinal-chemistry-cro-tags"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to add tag!", "error");
    },
  });
};

export const UpdateMedicinalChemistryCroTag = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: ({ id, data }) => client.medicinalChemistryCro.updateTag(id, data),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "Tag updated successfully!", "success");
        queryClient.invalidateQueries(["get-medicinal-chemistry-cro-tags"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to update tag!", "error");
    },
  });
};

export const DeleteMedicinalChemistryCroTag = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: (id) => client.medicinalChemistryCro.deleteTag(id),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "Tag deleted successfully!", "success");
        queryClient.invalidateQueries(["get-medicinal-chemistry-cro-tags"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to delete tag!", "error");
    },
  });
};

// FAQs
export const GetMedicinalChemistryCroFaqs = () => {
  return useQuery({
    queryKey: ["get-medicinal-chemistry-cro-faqs"],
    queryFn: () => client.medicinalChemistryCro.getAllFaqs(),
  });
};

export const AddMedicinalChemistryCroFaq = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: (data) => client.medicinalChemistryCro.addFaq(data),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "FAQ added successfully!", "success");
        queryClient.invalidateQueries(["get-medicinal-chemistry-cro-faqs"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to add FAQ!", "error");
    },
  });
};

export const UpdateMedicinalChemistryCroFaq = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: ({ id, data }) => client.medicinalChemistryCro.updateFaq(id, data),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "FAQ updated successfully!", "success");
        queryClient.invalidateQueries(["get-medicinal-chemistry-cro-faqs"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to update FAQ!", "error");
    },
  });
};

export const DeleteMedicinalChemistryCroFaq = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotifications();

  return useMutation({
    mutationFn: (id) => client.medicinalChemistryCro.deleteFaq(id),
    onSuccess: (response) => {
      if (response?.status === "success") {
        notify(response?.message || "FAQ deleted successfully!", "success");
        queryClient.invalidateQueries(["get-medicinal-chemistry-cro-faqs"]);
      } else {
        notify(response?.message || "Something went wrong!", "error");
      }
    },
    onError: (error) => {
      notify(error?.response?.data?.message || "Failed to delete FAQ!", "error");
    },
  });
};
